<template>
    <div>
        <v-snackbar :right="true" :timeout="3000" :top="true" color="error" v-model="snackbar">
            {{ notificationMessage }}
            <v-btn @click="snackbar = false" dark text>Close</v-btn>
        </v-snackbar>

        <div class="login-container">
            <v-card class="login-card">
                <v-card-text class="px-7 py-1">
                    <v-form @submit="login" action="#" ref="loginForm">
                        <top-header-section text-item="TREKKING AGENCY PORTAL"></top-header-section>
                      <v-alert
                          border="left"
                          colored-border
                          color="primary"
                          elevation="2"
                          class="mb-6 mt-4 portal-banner"
                      >
                        <div class="d-flex justify-space-between align-center flex-wrap">
                          <div>
                            <div class="text-h6 font-weight-bold">
                              New Trekking Agency Portal <br> Available
                            </div>
                          </div>

                          <v-btn
                              class="mt-3 ml-3 mt-sm-0"
                              color="primary"
                              depressed
                              rounded
                              href="https://nepaliport-new.immigration.gov.np/trekking/login"
                              target="_blank"
                          >
                            Visit New Portal
                            <v-icon right>mdi-open-in-new</v-icon>
                          </v-btn>
                        </div>
                      </v-alert>
                        <v-text-field
                            :rules="[rules.required]"
                            label="Mobile Number/Email"
                            outlined
                            prepend-inner-icon="fa fa-user color-blue"
                            type="text"
                            v-model="form.username"></v-text-field>
                        <v-text-field
                            :append-icon="passwordShow ? 'visibility_off' : 'visibility'"
                            :rules="[rules.required]"
                            :type="passwordShow ? 'text' : 'password'"
                            @click:append="passwordShow = !passwordShow"
                            label="Password"
                            outlined
                            prepend-inner-icon="mdi mdi-lock left-icon color-blue"
                            v-model="form.password"
                        ></v-text-field>
                        <v-btn  class="login-button" color="primary" large type="submit" :loading="loading">LOGIN
                        </v-btn>
                        <v-btn @click="$router.push('/register')" class="login-button mt-3"
                               color="primary"
                               large>Apply for Registration
                        </v-btn>
                        <v-flex class="mt-4" md12 text-center xs12>
                            <router-link to="/forget-password">
                                <v-btn color="primary" small text>Forgot Password ?</v-btn>
                            </router-link>
                        </v-flex>
                    </v-form>
                </v-card-text>
            </v-card>
        </div>
        <developed-by></developed-by>
    </div>
</template>

<script>
    import TopHeaderSection from "../../components/TopHeaderSection";
    import DevelopedBy from '../../components/DevelopedBy'

    export default {
        components: {TopHeaderSection, DevelopedBy},
        data: () => ({
            loading: false,
            snackbar: false,
            valid: true,
            dialog: false,
            notificationMessage: "",
            form: {
                username: "",
                password: ""
            },
            background: require("@/assets/banner.svg"),
            selected: null,
            passwordShow: false,
            passwordType: 'password',
            rules: {
                required: value => !!value || "Required.",
                emailMatch: () => "The email and password you entered don't match"
            },
        }),
        methods: {
            changePasswordType() {
                this.passwordType = this.passwordShow ? 'password' : 'text';
                this.passwordShow = !this.passwordShow;
            },
            async register() {
                window.location.href = "/register";
            },
            async login(e) {
                e.preventDefault();
                if (this.$refs.loginForm.validate()) {
                    let username = this.form.username;
                    let password = this.form.password;
                    try {
                        this.loading = true;
                        await this.$oauth.login(username, password);
                        let redirect = this.$route.query.redirect;
                        if (redirect) {
                            this.$router.replace(redirect);

                        } else {
                            this.$router.replace("/system/dashboard");

                        }
                        this.loading = false;
                    } catch (error) {
                        this.notificationMessage = "Invalid Credentials";
                        this.snackbar = true;
                        this.loading = false;
                    }
                }
            }
        }
    };
</script>
